<template>
    <v-container class="row-padding" grid-list-xl fluid>
        <v-expansion-panels focusable hover inset>
            <!--INTERVENTION DETAILS-->
            <v-expansion-panel class="mb-2">
                <v-expansion-panel-header class="pa-0" style="min-height:0" hide-actions>
                    <v-toolbar class="expand-panel-header-custom" dense dark>
                        <v-app-bar-nav-icon></v-app-bar-nav-icon>

                        <v-toolbar-title>Datos de la intervención</v-toolbar-title>

                        <v-spacer></v-spacer>

                        <v-btn icon>
                            <v-icon>mdi-information</v-icon>
                        </v-btn>
                    </v-toolbar>
                </v-expansion-panel-header>

                <v-expansion-panel-content class="filter-color pt-4">

                    <v-card id="info-card" class="item-card mx-auto pa-5" raised elevation="100">

                        <loading-wheel v-if="!intervention"></loading-wheel>
                        <v-card outlined class="filter-row-color my-3">
                            <v-container v-if="intervention" class="pa-5" grid-list-xl fluid>
                                <v-row no-gutters>
                                    <v-col cols="auto">
                                        <v-text-field label="Código" color="#da8d2b" style="max-width:90px"
                                            :value="intervention['cod']" hide-details="true" type="label" readonly fill>
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card>
                        <v-card outlined class="filter-row-color my-3">
                            <v-container v-if="intervention" class="pa-5" fluid>
                                <v-row no-gutters class="">
                                    <v-col cols="12">
                                        <v-row no-gutters justify="start" align="center">
                                            <v-text-field class="my-3 mr-10" style="max-width:50px" label="Orden"
                                                color="#da8d2b" :value="intervention['order']" hide-details="true"
                                                type="label" readonly fill>
                                            </v-text-field>
                                            <v-text-field class="my-3 mr-10" style="max-width:60px" label="Nº Turno"
                                                color="#da8d2b" :value="intervention['turn_number']" hide-details="true"
                                                type="label" readonly fill>
                                                <template v-slot:append>
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{ on }">
                                                            <v-icon dense v-on="on">mdi-format-list-numbers</v-icon>
                                                        </template>
                                                        "Número de turno en la conversación."
                                                    </v-tooltip>
                                                </template>
                                            </v-text-field>
                                            <v-text-field class="my-3 mr-10" style="max-width:95px"
                                                label="Nº Intervención" color="#da8d2b"
                                                :value="intervention['intervention_number']" hide-details="true"
                                                type="label" readonly fill>
                                                <template v-slot:append>
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{ on }">
                                                            <v-icon dense v-on="on">mdi-format-list-numbers</v-icon>
                                                        </template>
                                                        "Número de intervención del hablante."
                                                    </v-tooltip>
                                                </template>
                                            </v-text-field>
                                        </v-row>
                                        <v-row no-gutters justify="start" align="center">
                                            <v-text-field class="my-3 mr-10" style="max-width:105px" label="Inicio"
                                                color="#da8d2b" :value="intervention['start']" hide-details="true"
                                                type="label" readonly fill>
                                                <template v-slot:append>
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{ on }">
                                                            <v-icon dense v-on="on">mdi-ray-start-arrow</v-icon>
                                                        </template>
                                                        "Tiempo de inicio de la intervención."
                                                    </v-tooltip>
                                                </template>
                                            </v-text-field>
                                            <v-text-field class="my-3 mr-10" style="max-width:95px" label="Finalización"
                                                color="#da8d2b" :value="intervention['end']" hide-details="true"
                                                type="label" readonly fill>
                                                <template v-slot:append>
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{ on }">
                                                            <v-icon dense v-on="on">mdi-ray-end-arrow</v-icon>
                                                        </template>
                                                        "Tiempo de finalización de la intervención."
                                                    </v-tooltip>
                                                </template>
                                            </v-text-field>
                                            <v-text-field class="my-3 mr-5" style="max-width:100px" label="Duración"
                                                color="#da8d2b" v-model="intervention['duration']" hide-details="true"
                                                type="label" readonly fill>
                                                <template v-slot:append>
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{ on }">
                                                            <v-icon dense v-on="on">mdi-clock</v-icon>
                                                        </template>
                                                        "Tiempo de duración de la intervención."
                                                    </v-tooltip>
                                                </template>
                                            </v-text-field>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card>
                        <v-card outlined class="filter-row-color my-3">
                            <v-container v-if="intervention" class="pa-5" fluid>
                                <v-row no-gutters class="">
                                    <v-col cols="12">
                                        <v-row no-gutters justify="start" align="center">
                                            <v-text-field class="my-3 mr-10" style="max-width:135px" label="Tipo"
                                                color="#da8d2b" :value="intervention['intervention_type']['name']"
                                                hide-details="true" type="label" readonly fill>
                                            </v-text-field>
                                            <v-text-field class="my-3 mr-10" style="max-width:55px" label="Es turno"
                                                color="#da8d2b" :value="intervention['is_turn'] ? 'Sí' : 'No'"
                                                hide-details="true" type="label" readonly fill>
                                            </v-text-field>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card>
                        <v-card outlined class="filter-row-color my-3">
                            <v-container v-if="intervention" class="pa-5" fluid>
                                <v-row no-gutters class="">
                                    <v-col cols="12">
                                        <v-row no-gutters justify="start" align="center">
                                            <!--                                        <v-text-field
                                                                                        class="my-3 mr-10"
                                                                                        style="max-width:80px"
                                                                                        label="Actos"
                                                                                        color="#da8d2b"
                                                                                        :value="intervention['acts_count']"
                                                                                        hide-details="true"
                                                                                        type="label"
                                                                                        readonly
                                                                                        fill
                                                                                        >
                                                                                        <template v-slot:append>
                                                                                            <v-tooltip
                                                                                                bottom
                                                                                                >
                                                                                                <template v-slot:activator="{ on }">
                                                                                                    <v-icon dense v-on="on">mdi-text-to-speech</v-icon>
                                                                                                </template>
                                                                                                "Número de actos en la intervención."
                                                                                            </v-tooltip>
                                                                                        </template>
                                                                                    </v-text-field>-->
                                            <!--                                        <v-text-field
                                                                                        class="my-3 mr-10"
                                                                                        style="max-width:105px"
                                                                                        label="Subactos"
                                                                                        color="#da8d2b"
                                                                                        :value="intervention['subacts_count']"
                                                                                        hide-details="true"
                                                                                        type="label"
                                                                                        readonly
                                                                                        fill
                                                                                        >
                                                                                        <template v-slot:append>
                                                                                            <v-tooltip
                                                                                                bottom
                                                                                                >
                                                                                                <template v-slot:activator="{ on }">
                                                                                                    <v-icon dense v-on="on">mdi-hexagon-multiple</v-icon>
                                                                                                </template>
                                                                                                "Número de subactos en la intervención."
                                                                                            </v-tooltip>
                                                                                        </template>
                                                                                    </v-text-field>-->
                                            <v-text-field class="my-3 mr-10" style="max-width:75px" label="Palabras"
                                                color="#da8d2b" :value="intervention['tokens_count']"
                                                hide-details="true" type="label" readonly fill>
                                                <template v-slot:append>
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{ on }">
                                                            <v-icon dense v-on="on">font_download</v-icon>
                                                        </template>
                                                        "Número de palabras usadas en la intervención."
                                                    </v-tooltip>
                                                </template>
                                            </v-text-field>
                                            <v-text-field class="my-3 mr-5" style="max-width:80px" label="Duración"
                                                color="#da8d2b" :value="intervention['duration']" hide-details="true"
                                                type="label" readonly fill>
                                                <template v-slot:append>
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{ on }">
                                                            <v-icon dense v-on="on">mdi-clock</v-icon>
                                                        </template>
                                                        "Tiempo que dura la intervención."
                                                    </v-tooltip>
                                                </template>
                                            </v-text-field>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card>
                        <v-card outlined class="filter-row-color my-3">
                            <v-container v-if="intervention" class="pa-5" fluid>
                                <v-row no-gutters class="">
                                    <v-col cols="12">
                                        <v-row no-gutters justify="start" align="center" height="300">
                                            <v-textarea label="Contenido" color="#da8d2b"
                                                :value="intervention['metadata_contents']" hide-details="true" auto-grow
                                                readonly fill></v-textarea>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card>
                    </v-card>
                </v-expansion-panel-content>
            </v-expansion-panel>

            <!-- CONVERSATION SPEAKERS -->
            <v-expansion-panel class="mb-2">
                <v-expansion-panel-header class="pa-0" style="min-height:0" hide-actions>
                    <v-toolbar class="expand-panel-header-custom" dense dark>
                        <v-app-bar-nav-icon></v-app-bar-nav-icon>

                        <v-toolbar-title>Datos del hablante</v-toolbar-title>

                        <v-spacer></v-spacer>

                        <v-btn icon>
                            <v-icon>person</v-icon>
                        </v-btn>
                    </v-toolbar>
                </v-expansion-panel-header>

                <v-expansion-panel-content class="filter-color pt-4">
                    <v-card class="item-card mx-auto" raised elevation="100">

                        <loading-wheel v-if="!conversation_speakers"></loading-wheel>
                        <v-container v-if="conversation_speakers" class="pa-5" fluid>
                            <v-row no-gutters class="">
                                <v-col cols="12">
                                    <v-row no-gutters justify="start" align="center">
                                        <v-card class="intervention-speaker-container filter-row-color mb-4"
                                            style="width:100%" v-for="conversation_speaker in conversation_speakers"
                                            :key="conversation_speaker.cod" flat outlined tile>
                                            <v-card-title class="paddeless">
                                                Hablante<span style="margin-left: 5px">{{ conversation_speaker["key"]
                                                }}</span>
                                                <!--Hablante<span style="margin-left: 5px">{{conversation_speaker["name"]}} - {{conversation_speaker["key"]}}</span>-->
                                            </v-card-title>
                                            <v-list-item>
                                                <v-list-item-avatar style="color:white" color="black">{{
                                                    conversation_speaker["key"]
                                                }}</v-list-item-avatar>
                                                <!--                                            <v-list-item-content>
                                                                                                <v-list-item-title class="headline">Su nombre es {{conversation_speaker["name"]}}</v-list-item-title>
                                                                                                <v-list-item-subtitle>{{conversation_speaker['language_skill']?conversation_speaker['language_skill']['name']:''}}</v-list-item-subtitle>
                                                                                            </v-list-item-content>-->
                                            </v-list-item>
                                            <v-container class="pa-5" fluid>
                                                <v-row no-gutters justify="start" align="center">
                                                    <v-text-field class="my-3 mr-10" style="max-width:85px"
                                                        label="Género" color="#da8d2b"
                                                        :value="conversation_speaker['genre'] === 'H' ? 'Hombre' : 'Mujer'"
                                                        hide-details="true" type="label" readonly fill>
                                                        <template v-slot:append>
                                                            <v-icon
                                                                v-if="conversation_speaker['genre'] === 'H'">mdi-gender-male</v-icon>
                                                            <v-icon
                                                                v-if="conversation_speaker['genre'] === 'M'">mdi-gender-female</v-icon>
                                                        </template>
                                                    </v-text-field>
                                                    <v-text-field class="my-3 mr-10" label="Ciudad" color="#da8d2b"
                                                        :value="conversation_speaker['city']" hide-details="true"
                                                        type="label" readonly fill>
                                                    </v-text-field>
                                                    <v-text-field class="my-3 mr-10" label="País" color="#da8d2b"
                                                        :value="conversation_speaker['country']" hide-details="true"
                                                        type="label" readonly fill>
                                                    </v-text-field>
                                                    <v-text-field class="my-3 mr-10" style="max-width:225px"
                                                        label="Idioma" color="#da8d2b"
                                                        :value="conversation_speaker['language_skill'] ? conversation_speaker['language_skill']['name'] : ''"
                                                        hide-details="true" type="label" readonly fill>
                                                    </v-text-field>
                                                    <v-text-field class="my-3 mr-10" style="max-width:135px"
                                                        label="Profesión" color="#da8d2b"
                                                        :value="conversation_speaker['profession'] ? conversation_speaker['profession']['name'] : ''"
                                                        hide-details="true" type="label" readonly fill>
                                                    </v-text-field>
                                                    <v-text-field class="my-3 mr-10" style="max-width:135px"
                                                        label="Investigador participante" color="#da8d2b"
                                                        :value="conversation_speaker['active_pasive']"
                                                        hide-details="true" type="label" readonly fill>
                                                    </v-text-field>
                                                    <v-text-field class="my-3 mr-10" style="max-width:155px"
                                                        label="Relación" color="#da8d2b"
                                                        :value="conversation_speaker['speaker_relationship'] ? conversation_speaker['speaker_relationship']['name'] : ''"
                                                        hide-details="true" type="label" readonly fill>
                                                    </v-text-field>
                                                </v-row>
                                                <v-row no-gutters justify="start" align="center">
                                                    <!--                                                    <v-text-field
                                                                                                            class="my-3 mr-10"
                                                                                                            style="max-width:135px"
                                                                                                            label="Nivel instrucción"
                                                                                                            color="#da8d2b"
                                                                                                            :value="conversation_speaker['instruction_level']?conversation_speaker['instruction_level']['name']:''"
                                                                                                            hide-details="true"
                                                                                                            type="label"
                                                                                                            readonly
                                                                                                            fill
                                                                                                            >
                                                                                                        </v-text-field>-->
                                                    <v-text-field class="my-3 mr-10" style="max-width:135px"
                                                        label="Nivel sociocultural" color="#da8d2b"
                                                        :value="conversation_speaker['educational_level'] ? conversation_speaker['educational_level']['name'] : ''"
                                                        hide-details="true" type="label" readonly fill>
                                                    </v-text-field>
                                                    <v-text-field class="my-3 mr-10" style="max-width:135px"
                                                        label="Rango de edad" color="#da8d2b"
                                                        :value="conversation_speaker['age_range'] ? conversation_speaker['age_range']['name'] : ''"
                                                        hide-details="true" type="label" readonly fill>
                                                    </v-text-field>
                                                    <v-text-field class="my-3 mr-10" style="max-width:135px"
                                                        label="Rango de edad secundario" color="#da8d2b"
                                                        :value="conversation_speaker['age_range_2'] ? conversation_speaker['age_range_2']['name'] : ''"
                                                        hide-details="true" type="label" readonly fill>
                                                    </v-text-field>
                                                </v-row>
                                                <v-row no-gutters justify="start" align="center">
                                                    <v-textarea class="mt-3" label="Observaciones" color="#da8d2b"
                                                        :value="conversation_speaker['description']" hide-details="true"
                                                        auto-grow readonly fill outlined></v-textarea>
                                                </v-row>
                                            </v-container>
                                        </v-card>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
        <v-card class="discursive-units-card">
            <v-card-title class="discursive-units-card-title">
                Exploración por unidades discursivas
            </v-card-title>
            <v-expansion-panels focusable hover inset>

                <!--ACTS-->
                <v-expansion-panel v-if="acts.length > 0" class="mb-2">
                    <v-expansion-panel-header class="pa-0" style="min-height:0" hide-actions>
                        <v-toolbar class="expand-panel-header-custom" dense dark>
                            <v-app-bar-nav-icon></v-app-bar-nav-icon>

                            <v-toolbar-title>Actos</v-toolbar-title>

                            <v-spacer></v-spacer>

                            <v-btn icon>
                                <v-icon>mdi-text-to-speech</v-icon>
                            </v-btn>
                        </v-toolbar>
                    </v-expansion-panel-header>

                    <v-expansion-panel-content class="filter-color pt-4">

                        <v-card class="item-card mx-auto" raised elevation="100">

                            <v-container class="filter-row-color pa-5" fluid>
                                <v-row no-gutters class="">
                                    <v-col cols="12">
                                        <v-data-table class="transparent" show-expand single-expand item-key="cod"
                                            :headers="headers" :items="acts" :expanded.sync="expanded"
                                            @item-expanded="loadActDetails" @update="alert('')" locale="es-ES"
                                            :search="search_acts" :custom-filter="searchFilter" :loading="acts_loading"
                                            loading-text="Cargando datos..."
                                            no-data-text="No se han encontrado resultados" :footer-props="{
                                                itemsPerPageOptions: [10, 20, 30],
                                                'items-per-page-text': 'Actos por página'
                                            }">

                                            <template v-slot:top>
                                                <v-container grid-list-xl fluid>
                                                    <v-layout row wrap>
                                                        <v-flex class="row-padding" xs12>
                                                            <v-row no-gutters justify="end">
                                                                <v-col cols="auto">
                                                                    <v-text-field class="mx-4 my-3"
                                                                        style="max-width:300px" v-model="search_acts"
                                                                        append-icon="search" label="Filtrar" dense>
                                                                    </v-text-field>
                                                                </v-col>
                                                            </v-row>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-container>
                                            </template>

                                            <template v-slot:item="{ item, index, expand, isExpanded }">
                                                <tr :id="'row_' + item['cod']" :key="item.cod">
                                                    <td class="text-xs-left">
                                                        <v-btn small text icon @click="expand(!isExpanded)">
                                                            <v-icon color="primary"
                                                                v-if="isExpanded">mdi-chevron-down</v-icon>
                                                            <v-icon color="orange" v-else>mdi-chevron-right</v-icon>
                                                        </v-btn>
                                                    </td>
                                                    <!--                                        <td class="text-left body-1">
                                                                                            {{item["cod"]}}
                                                                                        </td>-->
                                                    <!--                                        <td class="text-left body-1">
                                                                                            {{item["conversation_speaker"]}}
                                                                                        </td>-->
                                                    <td>
                                                        <v-text-field class="discursive-unit-content text-center"
                                                            type="string" dense hide-details
                                                            v-html="item.metadata_contents">
                                                        </v-text-field>
                                                    </td>
                                                    <td class="text-center body-1">
                                                        {{ item.duration }}
                                                    </td>
                                                </tr>
                                            </template>

                                            <template v-slot:expanded-item="{ headers, item }">
                                                <td :colspan="headers.length" style="padding:0">
                                                    <v-card v-if="item" class="filter-color" flat tile>
                                                        <v-container class="px-5 py-3" fluid>
                                                            <v-row no-gutters>
                                                                <v-col cols="12">
                                                                    <v-row no-gutters justify="start" align="center">
                                                                        <!--                                                                    <v-text-field
                                                                                                                                            class="my-3 mr-10"
                                                                                                                                            style="max-width:80px"
                                                                                                                                            label="Subactos"
                                                                                                                                            color="#da8d2b"
                                                                                                                                            :value="expanded[0]['subacts_count']"
                                                                                                                                            hide-details="true"
                                                                                                                                            type="label"
                                                                                                                                            readonly
                                                                                                                                            fill
                                                                                                                                            >
                                                                                                                                            <template v-slot:append>
                                                                                                                                                <v-tooltip
                                                                                                                                                    bottom
                                                                                                                                                    >
                                                                                                                                                    <template v-slot:activator="{ on }">
                                                                                                                                                        <v-icon v-on="on">g_translate</v-icon>
                                                                                                                                                    </template>
                                    "Número de subactos en el acto."
                                    </v-tooltip>
                                    </template>
                                    </v-text-field>
                                    <v-text-field class="my-3 mr-10" style="max-width:80px" label="Palabras"
                                        color="#da8d2b" :value="expanded[0]['tokens_count']" hide-details="true"
                                        type="label" readonly fill>
                                        <template v-slot:append>
                                                                                                                                                <v-tooltip
                                                                                                                                                    bottom
                                                                                                                                                    >
                                                                                                                                                    <template v-slot:activator="{ on }">
                                                                                                                                                        <v-icon v-on="on">font_download</v-icon>
                                                                                                                                                    </template>
                                        "Número de palabras en el acto."
                                        </v-tooltip>
                                        </template>
                                    </v-text-field>-->
                                                                        <loading-wheel
                                                                            v-if="audio_is_loading"></loading-wheel>
                                                                        <div :id="'plyr_act_' + item['cod']">
                                                                            <audio id="audio_player">
                                                                            </audio>
                                                                        </div>
                                                                    </v-row>
                                                                    <v-row no-gutters justify="center" align="center">
                                                                        <v-btn rounded dense
                                                                            :to="getItemLink('act_details', item['cod'])"
                                                                            dark>
                                                                            <!-- @click.stop="openDetailedView('act_details', item['cod'])" -->
                                                                            <v-icon dark>pageview</v-icon>
                                                                            <span style="text-indent: 5px">Ver
                                                                                Detalles</span>
                                                                        </v-btn>
                                                                    </v-row>
                                                                </v-col>
                                                            </v-row>
                                                        </v-container>
                                                    </v-card>
                                                </td>
                                            </template>

                                            <template v-slot:[`footer.page-text`]="items"> {{ items.pageStart }} - {{
                                                items.pageStop }} de {{ items.itemsLength }} </template>
                                        </v-data-table>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card>
                    </v-expansion-panel-content>
                </v-expansion-panel>

                <!--TOKENS-->
                <v-expansion-panel v-if="tokens.length > 0" class="mb-2">
                    <v-expansion-panel-header class="pa-0" style="min-height:0" hide-actions>
                        <v-toolbar class="expand-panel-header-custom" dense dark>
                            <v-app-bar-nav-icon></v-app-bar-nav-icon>

                            <v-toolbar-title>Palabras</v-toolbar-title>

                            <v-spacer></v-spacer>

                            <v-btn icon>
                                <v-icon>mdi-voice</v-icon>
                            </v-btn>
                        </v-toolbar>
                    </v-expansion-panel-header>

                    <v-expansion-panel-content class="filter-color pt-4">

                        <v-card class="item-card mx-auto" raised elevation="100">

                            <v-container class="filter-row-color pa-5" fluid>
                                <v-row no-gutters class="">
                                    <v-col cols="12">
                                        <v-data-table class="transparent" show-expand single-expand item-key="cod"
                                            :headers="headers" :items="tokens" :expanded.sync="expanded"
                                            @item-expanded="loadTokenDetails" @update="alert('')" locale="es-ES"
                                            :search="search_tokens" :loading="tokens_loading"
                                            loading-text="Cargando datos..."
                                            no-data-text="No se han encontrado resultados" :footer-props="{
                                                itemsPerPageOptions: [10, 20, 30],
                                                'items-per-page-text': 'Palabras por página'
                                            }">

                                            <template v-slot:top>
                                                <v-container grid-list-xl fluid>
                                                    <v-layout row wrap>
                                                        <v-flex class="row-padding" xs12>
                                                            <v-row no-gutters justify="end">
                                                                <v-col cols="auto">
                                                                    <v-text-field class="mx-4 my-3"
                                                                        style="max-width:300px" v-model="search_tokens"
                                                                        append-icon="search" label="Filtrar" dense>
                                                                    </v-text-field>
                                                                </v-col>
                                                            </v-row>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-container>
                                            </template>

                                            <template v-slot:item="{ item, index, expand, isExpanded }">
                                                <tr :id="'row_' + item['cod']" :key="item.cod">
                                                    <td class="text-xs-left">
                                                        <v-btn small text icon @click="expand(!isExpanded)">
                                                            <v-icon color="primary"
                                                                v-if="isExpanded">mdi-chevron-down</v-icon>
                                                            <v-icon color="orange" v-else>mdi-chevron-right</v-icon>
                                                        </v-btn>
                                                    </td>
                                                    <!--                                        <td class="text-left body-1">
                                                                                            {{item["cod"]}}
                                                                                        </td>-->
                                                    <td>
                                                        <v-text-field class="discursive-unit-content text-center"
                                                            type="string" dense hide-details
                                                            v-html="item.metadata_contents">
                                                        </v-text-field>
                                                    </td>
                                                    <td class="text-center">
                                                        {{ item.duration }}
                                                    </td>
                                                </tr>
                                            </template>

                                            <template v-slot:expanded-item="{ headers, item }">
                                                <td :colspan="headers.length" style="padding:0">
                                                    <v-card v-if="item" class="filter-color" text tile>
                                                        <v-container class="px-5 py-3" fluid>
                                                            <v-row no-gutters>
                                                                <v-col cols="12">
                                                                    <v-row no-gutters justify="center" align="center">
                                                                        <loading-wheel
                                                                            v-if="audio_is_loading"></loading-wheel>
                                                                        <div :id="'plyr_token_' + item['cod']">
                                                                            <audio id="audio_player">
                                                                            </audio>
                                                                        </div>
                                                                    </v-row>
                                                                    <v-row no-gutters justify="center" align="center">
                                                                        <v-btn class="ml-10" rounded dense
                                                                            :to="getItemLink('token_details', item['cod'])"
                                                                            dark>
                                                                            <!-- @click.stop="openDetailedView('token_details', item['cod'])" -->
                                                                            <v-icon dark>pageview</v-icon>
                                                                            <span style="text-indent: 5px">Ver
                                                                                Detalles</span>
                                                                        </v-btn>
                                                                    </v-row>
                                                                </v-col>
                                                            </v-row>
                                                        </v-container>
                                                    </v-card>
                                                </td>
                                            </template>

                                            <template v-slot:[`footer.page-text`]="items"> {{ items.pageStart }} - {{
                                                items.pageStop }} de {{ items.itemsLength }} </template>
                                        </v-data-table>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </v-card>
    </v-container>
</template>
<script>
import api from '@/restApi';
import { Breadcrumb, Loading } from '@/components';

export default {
    name: 'intervention-details',
    bodyClass: 'default-page',
    props: {
        code: {
            type: String,
            default() {
                return "";
            }
        }
    },
    data() {
        return {
            page: null,
            section: null,
            subsection: null,
            search_acts: "",
            player: null,
            intervention: null,
            conversation_speakers: [],
            acts: [],
            tokens: [],
            conversation_speakers_loading: true,
            acts_loading: true,
            tokens_loading: true,
            alternate: false,
            audio_is_loading: true,
            expanded: [],
            headers: [
                //                    {
                //                        text: "Id",
                //                        align: "left",
                //                        sortable: "false",
                //                        value: "cod"
                //                    },
                {
                    text: "Contenido",
                    align: "left",
                    sortable: "false",
                    value: "metadata_contents"
                },
                {
                    text: "Dur.",
                    align: "center",
                    value: "duration",
                    width: 100
                }
            ]
        };
    },
    created: function () {
        const params = this.$route.params;

        this.page = params.page;
        this.section = params.section;
        this.subsection = params.subsection;

        this.loadInterventionData();
    },
    mounted: function () {
    },
    watch: {
    },
    methods: {
        getItemLink(view, cod) {
            const link = '/pages/' + this.page + "/" + this.section + "/" + this.subsection + "/" + view + "/" + cod;

            return link;
        },
        searchFilter(value, search, item) {
            //                console.log(value + " - " + search + " - " + item);

            return (value !== null &&
                search !== null && typeof value === 'string' &&
                this.$mout.string.contains(item.metadata_contents, search));
        },
        async loadActDetails({ item }) {
            var elementId, conversationCode;
            var start, duration;
            var isExpanding;
            var self = this;

            self.audio_is_loading = true;

            self.alternate = !self.alternate;

            //                console.log(self.expanded)
            isExpanding = !this.$mout.array.filter(self.expanded, function (item2) {
                //                console.log(item2["cod"],"-",item["cod"])
                return item2["cod"] === item["cod"];
            }).length > 0;
            //                console.log("EOOOOOOOOOOOOOOOOOOOOO",isExpanding)

            if (this.$mout.lang.isEmpty(item) || !isExpanding) {
                return;
            }

            //                console.log("Element", "plyr_act_" + item["cod"]);
            //                console.log("Expanded item", item);

            elementId = "#audio_player";
            conversationCode = item["cod"].substring(0, item["cod"].indexOf("-"));
            start = item["start"];
            duration = item["end"] - item["start"];

            if (self.player) {
                self.player.destroy();
            }

            setTimeout(async function () {
                self.player = await self.loadPlayer(elementId, conversationCode, start, duration, self.audio_is_loading);

                self.audio_is_loading = false;
            }, 10);
        },
        async loadTokenDetails({ item }) {
            var elementId, conversationCode;
            var start, duration;
            var isExpanding;
            var self = this;

            self.audio_is_loading = true;

            self.alternate = !self.alternate;

            //                console.log(self.expanded)
            isExpanding = !this.$mout.array.filter(self.expanded, function (item2) {
                //                console.log(item2["cod"],"-",item["cod"])
                return item2["cod"] === item["cod"];
            }).length > 0;
            //                console.log("EOOOOOOOOOOOOOOOOOOOOO",isExpanding)

            if (this.$mout.lang.isEmpty(item) || !isExpanding) {
                return;
            }

            //                console.log("Element", "plyr_token_" + item["cod"]);
            //                console.log("Expanded item", item);

            elementId = "#audio_player";
            conversationCode = item["cod"].substring(0, item["cod"].indexOf("-"));
            start = item["start"];
            duration = item["end"] - item["start"];

            if (self.player) {
                self.player.destroy();
            }

            setTimeout(async function () {
                self.player = await self.loadPlayer(elementId, conversationCode, start, duration, self.audio_is_loading);

                self.audio_is_loading = false;
            }, 10);
        },
        openDetailedView(view, inputParams, modifiers) {
            this.$emit('clicked', view + (inputParams ? "/" + inputParams : "") + "/" + (modifiers ? "/" + inputParams : ""));
        },
        async loadInterventionData() {
            await this.loadIntervention();
            this.loadConversationSpeaker(this.intervention["conversation_speaker"]);
            await this.loadActs();
            if (this.$mout.lang.isEmpty(this.acts)) {
                this.loadTokens();
            }
        },
        async loadIntervention() {
            const queryString = "cod=" + this.code + "&populate=intervention_type&fields=cod,metadata_contents,start,end";

            // Get the intervention with given code
            const response = await api.get("intervention", queryString);

            if (response instanceof Error) {
                // Do not continue
                return;
            }

            const interventions = response;

            if (interventions.length <= 0) {
                return;
            }

            this.intervention = interventions[0];

            this.intervention["duration"] = this.millisToMinutesAndSeconds(this.intervention["end"] - this.intervention["start"]);
            this.intervention["start"] = this.millisToMinutesAndSeconds(this.intervention["start"]);
            this.intervention["end"] = this.millisToMinutesAndSeconds(this.intervention["end"]);

            //                console.log(JSON.stringify(this.intervention));
        },
        async loadConversationSpeaker(conversationSpeaker) {
            this.conversation_speakers_loading = true;

            const queryString = "cod=" + conversationSpeaker + "&populate=instruction_level,educational_level,age_range,age_range_2,speaker_relationship,profession,language_skill,&sort={\"field\":\"name\",\"dir\":\"asc\"}";

            // Get the conversation speaker by code
            const response = await api.getAllItems("conversation_speaker", queryString);

            if (response instanceof Error) {
                // Do not continue
                return;
            }

            const conversationSpeakers = response;

            this.conversation_speakers = conversationSpeakers;

            this.conversation_speakers_loading = false;
        },
        async loadActs() {
            this.acts_loading = true;

            const queryString = "intervention=" + this.intervention["_id"] + "&fields=cod,metadata_contents,start,end&sort={\"field\":\"order\",\"dir\":\"asc\"}";

            // Get acts for intervention
            const response = await api.getAllItems("act", queryString);

            if (response instanceof Error) {
                // Do not continue
                return;
            }

            const acts = response;

            for (var act of acts) {
                //                    acts[i]["conversation_speaker"] = this.conversation_speaker["cod"];
                act["duration"] = this.millisToMinutesAndSeconds(act["end"] - act["start"]);
            }

            this.acts = acts;

            this.acts_loading = false;
        },
        async loadTokens() {
            this.tokens_loading = true;

            const queryString = "intervention=" + this.intervention["_id"] + "&sort={\"field\":\"order\",\"dir\":\"asc\"}";

            // Get intervention tokens
            const response = await api.getAllItems("token", queryString);

            if (response instanceof Error) {
                // Do not continue
                return;
            }

            const tokens = response;

            for (var token of tokens) {
                //                    if (this.$mout.lang.isEmpty(token["metadata_contents"])) {
                token["metadata_contents"] = token["cleaned_contents"];
                //                    }
                token["duration"] = this.millisToMinutesAndSeconds(token["end"] - token["start"]);
            }

            this.tokens = tokens;

            this.tokens_loading = false;
        }
    },
    components: {
        [Breadcrumb.name]: Breadcrumb,
        [Loading.name]: Loading
    }
};
</script>
<style>
.intervention-speaker-container {
    border-bottom: 1px solid black !important;
}

.paddeless {
    padding: 0 !important;
}

.transparent>.table,
.transparent>.table__overflow>.table,
.transparent>.table>.datatable__actions {
    background-color: #fde19a;
}
</style>
